import { useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'

import { useAuthContext } from '../components/Authentication/hooks/useAuthContext'
import { LayoutStyles } from '../components/Authentication/styles'
import { resolveSession } from '../components/UI/GoogleAuthButton'
import { Loader } from '../components/UI/Loader'
import { useRoute } from '../hooks/useRoute'

export const AuthCheckPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { signInRoute } = useRoute()
    const from = `${(location.state as any)?.from?.pathname ?? ''}${(location.state as any)?.from?.search ?? ''}` || '/'
    const session = location.state?.session

    const { isAuthenticated, isLoading, hasLoaded } = useAuthContext().user

    // Resolve session from Google Auth
    resolveSession(session)

    // Check user authentication on load
    useEffect(() => {
        if (isLoading) {
            return
        }

        // Else navigate to original route that is auth-protected
        else if (isAuthenticated) {
            navigate(from, { replace: true, state: { session } })
        }
    }, [isAuthenticated, from, isLoading, navigate, session])

    // If user is unable to be fetched, then navigate to signin page
    if (!isAuthenticated && hasLoaded) {
        return <Navigate to={signInRoute} replace />
    }

    return (
        <LayoutStyles>
            <Loader className="m-3" />
        </LayoutStyles>
    )
}
